import { LayoutTableContainer } from '@/pages/orders/_layouts/LayoutTableContainer';
import { LayoutReviewContainer, LayoutReviewsBody } from '../../_layouts/LayoutsReviews';
import ReviewsBody from './ReviewsBody';

import type { ReviewItem } from '@/types/api';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';

interface TableSectionProps {
  isLoading?: boolean;
  tableOrderList: ReviewItem[];
  allMarketsQueries: any; // Adjust type as necessary
}
const TableSection = ({ allMarketsQueries, isLoading, tableOrderList }: TableSectionProps) => {
  if (isLoading) return <GlobalSpinner />;

  return (
    <LayoutTableContainer className="pt-0">
      <LayoutReviewContainer>
        <LayoutReviewsBody>
          <ReviewsBody allMarketsQueries={allMarketsQueries} reviews={tableOrderList} />
        </LayoutReviewsBody>
      </LayoutReviewContainer>
    </LayoutTableContainer>
  );
};

export default TableSection;
